<!-- displaying the latest graph with all the details -->
<!-- loader-->
<ng-container *ngIf="loading">
  <div class="loading">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</ng-container>
<!-- end of loader-->
<ng-container *ngIf="!loading">
  <!-- checking authorization-->
  <ng-container *ngIf="role !== 'CUSTOMER'">
    Unauthorized
  </ng-container>
  <!-- calling curve analyser-->
  <ng-container *ngIf="role === 'CUSTOMER'">
    {{sendCurveDataToAnalyser()}}
  </ng-container>
</ng-container>
<!-- end of graph display-->
